
export const SET =  (state, [variable, value]) =>{
    state[variable] = value
}

export const ONE_TIME_PACKAGES =  (state,data) =>{
    state.oneTimePackages = data;
}


